import { useEffect, useRef } from 'react';
import Clarity from '@microsoft/clarity';

export const useMsClarity = (): void => {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!(window.location.href.includes('localhost') || initializedRef.current)) {
      const projectId = window.location.href.includes('app.enmon') ? 't5ea0oilr5' : 'tmwdlkzpk3';

      Clarity.init(projectId);
      initializedRef.current = true;
    }
  }, []);
};
